
<p-dialog [modal]="true"
          [(visible)]="transactionDetailsDialog.visible"
          [style]="{width: '50rem'}"
          [closable]="true"
          [resizable]="false"
          [draggable]="false"
          (visibleChange)="$event === false ? closeDetailsDialog() : null">
  <ng-template pTemplate="header">
    <div class="text-lg font-bold">
      {{ transactionDetailsHeader }}
    </div>
  </ng-template>
  @if (transactionDetailsDialog.visible) {
    <sps-transaction-details-dialog [transactionViewMode]="transactionViewMode"
                                    [transactionId]="selectedRowData.id"
                                    titleColumnWidth="200px">
    </sps-transaction-details-dialog>
  }
  <ng-template #footer class="pt-3">
    <p-button [label]="i18n.i18nLng()['CLOSE']" (onClick)="closeDetailsDialog()" />
  </ng-template>
</p-dialog>
<div class="grid">
  <div class="col-12">
    <p-card class="h-full">
      <ng-template pTemplate="title">
        <div class="text-sm text-primary mb-3">
          {{ transactionDataService?.selectedOrganisationName }}
        </div>
        <div class="flex flex-1 gap-2 align-self-stretch" [ngClass]="layoutService.isMobile() ? 'align-items-start' : 'align-items-center'">
          <div class="flex flex-1" [ngClass]="layoutService.isMobile() ? 'flex-column justify-content-center align-items-start gap-4' : 'align-items-center gap-3'">
            <p-select-button [options]="stateOptions"
                             [(ngModel)]="currentState"
                             [allowEmpty]="false"
                             optionLabel="label"
                             optionValue="value"
                             [attr.aria-label]="i18n.i18nLng()['STATE']"
                             (onChange)="tableStatusChanged()">
            </p-select-button>
            <div style="word-break: keep-all">{{ totalRecords.toString() + ' ' + i18n?.i18nLng()['TRANSACTIONS'] }}</div>
          </div>
          <div [ngClass]="layoutService.isMobile() ? 'flex flex-column gap-2 align-items-start' : 'flex flex-1 gap-2 align-self-stretch align-items-center justify-content-end'">
            <p-button [label]="i18n.i18nLng()['CLEAR']"
                      [ariaLabel]="i18n?.i18nLng()['CLEARALLFILTERS']"
                      [pTooltip]="i18n?.i18nLng()['CLEARALLFILTERS']"
                      tooltipPosition="top"
                      [outlined]="true"
                      icon="pi pi-filter-slash"
                      (click)="clearTableFilters()"/>
            <!-- currently no export of tenent transactions for admins -->
            <!--
            <p-button icon="pi pi-file-export"
                      [label]="i18n?.i18nLng()['EXPORTDATA']"
                      [ariaLabel]="i18n?.i18nLng()['EXPORTDATA']"
                      [disabled]="totalRecords === 0"
                      (onClick)="exportTransactionData()"/>
             -->
          </div>
        </div>
      </ng-template>
      @if (!tableControlService.refreshTableConfig()) {
        <sps-table [tableConfig]="tableConfig()"
                   [rows]="rows"
                   [tableListProvider]="tableListProvider"
                   [parentDataProvider]="getTransactionPageData"
                   [parentDataMapper]="transactionDataMapper"
                   [tableControlService]="tableControlService"
                   [scrollHeightOffset]="scrollHeightOffset"
                   [minScrollHeight]="minScrollHeight"
                   [freezeColumns]="true"
                   [showTogglerIcon]="true"
                   (tableInitialized)="tableComponent = $event"
                   (dataFetched)="onDataFetched($event)"
                   (selectionChanged)="onSelectionChanged($event)"
                   (rowsCountChanged)="rowsCountChanged($event)">
        </sps-table>
      }
    </p-card>
  </div>
</div>
